export default [
  {
    "id": "mat-enem-0898",
    "numero": 2398,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "O gráfico apresenta a taxa de desemprego (em%) para o período de março de 2008 a abril de 2009, \nobtida com base nos dados observados nas regiões metropolitanas de Recife, Salvador, Belo Horizonte, \nRio de Janeiro, São Paulo e Porto Alegre. \n \n \n \nA mediana dessa taxa de desemprego, no período de março de 2008 a abril de 2009, foi de: \n \nA) 8,1% \nB) 8,0% \nC) 7.9% \nD) 7,7% \nE) 7,6%",
    "alternativas": {
      "A": "8,1%",
      "B": "8,0%",
      "C": "7.9%",
      "E": "7,6%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 898,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0899",
    "numero": 2399,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Para uma temporada das corridas de Fórmula 1, a capacidade do tanque de combustível de cada carro \npassou a ser de 100 kg de gasolina. Uma equipe optou por utilizar uma gasolina com densidade de 750 \ngramas por litro, iniciando a corrida com o tanque cheio.  \n \nNa primeira parada de reabastecimento, um carro dessa equipe apresentou um registro em seu compu-\ntador de bordo acusando o consumo de quatro décimos da gasolina originalmente existente no tanque. \nPara minimizar o peso desse carro e garantir o término da corrida, a equipe de apoio reabasteceu o car-\nro com a terça parte do que restou no tanque na chegada ao reabastecimento. \n \n(Disponível em: www.superdaniloflpage.com.br. Acesso em: 6 jul.2015 - adaptado) \n \nA quantidade de gasolina utilizada, em litro, no reabastecimento foi: \n \nA) 20/0,075 \nB) 20/0,75 \nC) 20/7,5 \nD) 20 x 0,075 \nE) 20 X 0,75",
    "alternativas": {
      "B": "20/0,75",
      "C": "20/7,5",
      "D": "20 x 0,075",
      "A": "20/0,075"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 899,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0900",
    "numero": 2400,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "A energia solar vai abastecer parte da demanda de energia do campus de uma universidade brasileira. A \ninstalação de painéis solares na área dos estacionamentos e na cobertura do hospital pediátrico será \naproveitada nas instalações universitárias e também ligada na rede da companhia elétrica distribuidora \nde energia.  \n \nO projeto inclui 100 m2 de painéis solares que ficarão instalados nos estacionamentos, produzindo ener-\ngia elétrica e proporcionando sombra para os carros. Sobre o hospital pediátrico serão colocados apro-\nximadamente 300 m2 de painéis, sendo 100 m2 para gerar energia elétrica utilizada no campus, e 200 m2 \npara geração de energia térmica, produzindo aquecimento de água utilizada nas caldeiras do hospital.  \n \nSuponha que cada metro quadrado de painel Solar para energia elétrica gere uma economia de 1 kWh \npor dia e cada metro quadrado produzindo energia térmica permita economizar 0,7 kWh por dia para a \nuniversidade. Em uma segunda fase do projeto, será aumentada em 75% a área coberta pelos painéis \nsolares que geram energia elétrica. Nessa fase também deverá ser ampliada a área de cobertura com \npainéis para geração de energia térmica. \n \n(Disponível em: http://agenciabrasil.ebc.com.br. Acesso em:30 Out 2013 - adaptado) \n \nPara se obter o dobro da quantidade de energia economizada diariamente, em relação à primeira fase, a \nárea total dos painéis que geram energia térmica, em metro quadrado, deverá ter o valor mais próximo \nde: \n \nA) 231. \nB) 431. \nC) 472. \nD) 523. \nE) 672.",
    "alternativas": {
      "D": "523.",
      "E": "672.",
      "B": "431.",
      "C": "472."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.1",
    "numeroOriginal": 900,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0901",
    "numero": 2401,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "No próximo fim de semana, uma pessoa receberá visitas em sua casa, precisando, portanto, comprar \nrefrigerante. Para isso, ela fez a pesquisa de preços em dois supermercados e montou esta tabela. \n \n \n \nEla pretende comprar apenas garrafas que tenham a mesma capacidade. \n \nIndependentemente de em qual supermercado essa pessoa fará a compra, a fim de ter o menor custo, \nela deverá adquirir garrafas com que capacidade? \n \nA) 500 mL \nB) 1,5 L \nC) 2,0 L \nD) 2,5 L \nE) 3,0 L",
    "alternativas": {
      "E": "3,0 L",
      "A": "500 mL",
      "C": "2,0 L",
      "D": "2,5 L"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 901,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0902",
    "numero": 2402,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Em uma embalagem de farinha encontra-se a \nreceita de um bolo, sendo parte dela reproduzi-\nda a seguir: \n \n \n \nPossuindo apenas a colher medida indicada na \nreceita, uma dona de casa teve que fazer algu-\nmas conversões para poder medir com precisão \na farinha. Considere que a farinha e o fermento \npossuem densidades iguais. \n \nCada xícara indicada na receita é equivalente a \nquantas colheres medidas? \n \nA) 10 \nB) 20 \nC) 40 \nD) 80 \nE) 320",
    "alternativas": {
      "A": "10",
      "B": "20",
      "D": "80",
      "E": "320"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 902,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0903",
    "numero": 2403,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Numa tarefa escolar, um aluno precisava fazer a \nplanta baixa de sua casa em uma escala de      \n1 : 40. Ele verificou que a base da casa era \nretangular, tendo 12 metros de comprimento e 8 \nmetros de largura. O aluno foi a uma papelaria e \nlá observou que havia cinco tipos de folhas de \npapel, todas com diferentes dimensões. O qua-\ndro contém os cinco tipos de folhas, com seus \ncomprimentos e larguras fornecidos em centí-\nmetro. \n \n \n \nO aluno analisou os cinco tipos de folha e com-\nprou a que possuía as dimensões mínimas ne-\ncessárias para que ele fizesse a planta de sua \ncasa na escala desejada, deixando exatamente \n2 centímetros de margem em cada um dos qua-\ntro lados da folha. \nA folha escolhida pelo aluno foi a de tipo: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "D": "IV.",
      "A": "I.",
      "B": "II.",
      "C": "III."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 903,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0904",
    "numero": 2404,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Em alguns países anglo-saxões, a unidade de \nvolume utilizada para indicar o conteúdo de \nalguns recipientes é a onça fluida britânica. O \nvolume de uma onça fluida britânica correspon-\nde a 28,4130625 mL. \n \nA título de simplificação, considere uma onça \nfluida britânica correspondendo a 28 mL. \n \nNessas condições, o volume de um recipiente \ncom capacidade de 400 onças fluidas britânicas, \nem cm3, é igual a: \n \nA) 11200. \nB) 1120. \nC) 112. \nD) 11,2. \nE) 1,12.",
    "alternativas": {
      "D": "11,2.",
      "A": "11200.",
      "B": "1120.",
      "C": "112."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 904,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0905",
    "numero": 2405,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma aluna estuda numa turma de 40 alunos. \nEm um dia, essa turma foi dividida em três sa-\nlas, A, B e C, de acordo com a capacidade das \nsalas. Na sala A ficaram 10 alunos, na B, outros \n12 alunos e na C, 18 alunos. Será feito um sor-\nteio no qual, primeiro, será sorteada uma sala e, \nposteriormente, será sorteado um aluno dessa \nsala. \n \nQual é a probabilidade de aquela aluna especí-\nfica ser sorteada, sabendo que ela está na sala \nC? \n \nA) 1/3 \nB) 1/18 \nC) 1/40 \nD) 1/54 \nE) 7/18",
    "alternativas": {
      "D": "1/54",
      "E": "7/18",
      "B": "1/18",
      "C": "1/40"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 905,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0906",
    "numero": 2406,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Os computadores operam com dados em forma-\nto binário (com dois valores possíveis apenas \npara cada dígito), utilizando potências de 2 para \nrepresentar quantidades. Assim, tem-se, por \nexemplo: 1kB = 210 Bytes, 1 MB = 210 kB e 1 GB \n= 210 MB, sendo que 210 = 1024. Nesse caso, \ntem-se que kB significa quilobyte, MB significa \nmegabyte e GB significa gigabyte. Entretanto, a \nmaioria dos fabricantes de discos rígidos, pen-\ndrives ou similares adotam preferencialmente o \nsignificado usual desses prefixos, em base 10. \nAssim, \nnos \nprodutos \ndesses \nfabricantes,       \n1GB = 103 MB = 106 kB = 109 Bytes. Como a \nmaioria dos programas de computadores utili-\nzam as unidades baseadas em potências de 2, \num disco informado pelo fabricante como sendo \nde 80 GB aparecerá aos usuários como pos-\nsuindo, aproximadamente, 75 GB. \n \nUm disco rígido está sendo vendido como pos-\nsuindo 500 gigabytes, considerando unidades \nem potências de 10. \n \nQual dos valores está mais próximo do valor \ninformado por um programa que utilize medidas \nbaseadas em potências de 2? \n \nA) 468 GB \nB) 476 GB \nC) 488 GB \nD) 500 GB \nE) 533 GB",
    "alternativas": {
      "C": "488 GB",
      "D": "500 GB",
      "E": "533 GB",
      "A": "468 GB"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 906,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0907",
    "numero": 2407,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Um motorista de um carro flex (bicombustível) \ncalcula que, abastecido com 45 litros de gasoli-\nna ou com 60 litros de etanol, o carro percorre a \nmesma distância. \n \nChamando de x o valor do litro de gasolina e de \ny o valor do litro de etanol, a situação em que \nabastecer com gasolina é economicamente \nmais vantajosa do que abastecer com etanol é \nexpressa por: \n \nA) \n3\n4\n\ny\nx\n \n \nB) \n4\n3\n\ny\nx\n \n \nC) \n3\n4\n\ny\nx\n \n \nD) \n4\n3\n\ny\nx\n \n \nE) \n3\n4\n\ny\nx",
    "alternativas": {
      "E": "3 4  y x",
      "A": "3 4  y x",
      "B": "4 3  y x",
      "D": "4 3  y x"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 907,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0908",
    "numero": 2408,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "GH é a sigla que denomina o hormônio do cres-\ncimento (do inglês growth hormone), indispen-\nsável para retardar o processo de envelheci-\nmento. À medida que envelhecemos, a libera-\nção desse hormônio na corrente sanguínea vai \ndiminuindo. Estudos têm demonstrado, porém, \nque alguns métodos de treinamento aumentam \na produção de GH. Em uma pesquisa, dez ho-\nmens foram submetidos a sessões de 30 minu-\ntos de corrida, em uma esteira, em diferentes \nintensidades: muito leve, leve, moderada e má-\nxima. As dosagens de GH, medidas por coletas \nde sangue feitas antes e logo após as sessões, \ne também 1 hora e 2 horas após o término, são \nfornecidas no gráfico. \n \n \n \nEm qual(is) medição(ões) a liberação de GH na \ncorrente sanguínea em uma sessão de intensi-\ndade máxima foi maior que a liberação de GH \nocorrida nas demais intensidades? \n \nA) Apenas na medição feita logo após a sessão \nde treinamento. \nB) Apenas na medição feita 1 hora após a ses-\nsão de treinamento. \nC) Apenas na medição feita 2 horas após a \nsessão de treinamento. \nD) Nas medições feitas logo após e 1 hora após \na sessão de treinamento. \nE) Nas medições feitas logo após, 1 hora após e \n2 horas após a sessão do treinamento.",
    "alternativas": {
      "A": "Apenas na medição feita logo após a sessão de treinamento.",
      "B": "Apenas na medição feita 1 hora após a ses- são de treinamento.",
      "C": "Apenas na medição feita 2 horas após a sessão de treinamento.",
      "D": "Nas medições feitas logo após e 1 hora após a sessão de treinamento."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 908,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0909",
    "numero": 2409,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Chegando ao destino de uma mesma viagem, \nos turistas X e Y alugarão, cada um deles, um \ncarro. Fizeram previamente, cotações com as \nmesmas três locadoras de automóveis da regi-\não. Os valores dos aluguéis estão representa-\ndos pelas expressões dadas no quadro, sendo \nK o número de quilômetros percorridos, e N o \nnúmero de diárias pagas pelo aluguel. \nO turista X alugará um carro em uma mesma \nlocadora por três dias e percorrerá 250 km. Já a \npessoa Y usará o carro por apenas um dia e \npercorrerá 120 km. \n \nCom o intuito de economizarem com as loca-\nções dos carros, e mediante as informações, os \nturistas X e Y alugarão os carros, respectiva-\nmente, nas empresas: \n \nA) I e II. \nB) I e III. \nC) II e II. \nD) II e III. \nE) III e I.",
    "alternativas": {
      "D": "II e III.",
      "A": "I e II.",
      "B": "I e III.",
      "C": "II e II."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 909,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0910",
    "numero": 2410,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "O governo decidiu reduzir de 25% para 20% o \nteor de álcool anidro misturado à gasolina ven-\ndida nos postos do país.  \n \nConsidere que a média de desempenho, ou \nseja, a quantidade de quilômetros (km) que um \ncarro anda com 1 litro de combustível, é direta-\nmente proporcional à porcentagem de gasolina \npresente no combustível, e que a média de de-\nsempenho de um carro antes da decisão do \ngoverno era de 13,5km/L. \n \nNas condições do texto, qual será a estimativa \nda média de desempenho após a redução de \nálcool anidro no combustível? \n \n \nA) 10,80 km/L \nB) 12,65 km/L \nC) 12,82 km/L \nD) 14,15 km/L \nE) 14,40 km/L",
    "alternativas": {
      "D": "14,15 km/L",
      "E": "14,40 km/L",
      "B": "12,65 km/L",
      "C": "12,82 km/L"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 910,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0911",
    "numero": 2411,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Numa turma de inclusão de jovens e adultos a \neducação formal profissional (Proeja), a média \naritmética das idades dos seus dez alunos é de \n32 anos. Em determinado dia, o aluno mais \nvelho da turma faltou e, com isso, a média arit-\nmética das idades dos nove alunos presentes \nfoi de 30 anos. \n \n(Disponível em: http://portal.mec.gov.br.  \nAcesso em: 10 mar. 2012 - adaptado) \n \nQual é a idade do aluno que faltou naquela tur-\nma? \n \nA) 18 \nB) 20 \nC) 31 \nD) 50 \nE) 62",
    "alternativas": {
      "A": "18",
      "C": "31",
      "D": "50",
      "E": "62"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 911,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0912",
    "numero": 2412,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Cinco regiões de um país estão buscando re-\ncursos no Governo Federal para diminuir a taxa \nde desemprego de sua população. Para decidir \nqual região receberia o recurso, foram colhidas \nas taxas de desemprego, em porcentagem, dos \núltimos três anos. Os dados estão apresentados \nna tabela. \n \n \n \nFicou decidido que a região contemplada com a \nmaior parte do recurso seria aquela com a maior \nmediana das taxas de desemprego dos últimos \ntrês anos. \n \nA região que deve receber a maior parte do \nrecurso é a: \n \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "A": "A.",
      "B": "B.",
      "D": "D.",
      "E": "E."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 912,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0913",
    "numero": 2413,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma empresa de entregas presta serviços para \noutras empresas que fabricam e vendem produ-\ntos. Os fabricantes dos produtos podem contra-\ntar um entre dois planos oferecidos pela empre-\nsa que faz as entregas. No plano A, cobra-se \numa taxa fixa mensal no valor de R$500,00, \nalém de uma tarifa de R$4,00 por cada quilo-\ngrama enviado (para qualquer destino dentro da \nárea de cobertura). No plano B, cobra-se uma \ntaxa fixa mensal no valor de R$ 200,00, porém a \ntarifa por cada quilograma enviado sobe para \nR$ 6,00. Certo fabricante havia decidido contra-\ntar o plano A por um período de 6 meses. Con-\ntudo, ao perceber que ele precisará enviar ape-\nnas 650 quilogramas de mercadoria durante \ntodo o período, ele resolveu contratar o plano B. \n \nQual alternativa avalia corretamente a decisão \nfinal do fabricante de contratar o plano B? \n \nA) A decisão foi boa para o fabricante, pois o \nplano B custará ao todo R$ 500,00 a menos do \nque o plano A custaria. \nB) A decisão foi boa para o fabricante, pois o \nplano B custará ao todo R$ 1500,00 a menos do \nque o plano A custaria. \nC) A decisão foi ruim para o fabricante, pois o \nplano B custará ao todo R$ 1000,00 a mais do \nque o plano A custaria. \nD) A decisão foi ruim custará ao todo              \nR$ 1300,00 a mais do que o plano A custaria. \nE) A decisão foi ruim para o fabricante, pois o \nplano B custará ao todo R$ 6000,00 a mais do \nque o plano A custaria.",
    "alternativas": {
      "A": "A decisão foi boa para o fabricante, pois o plano B custará ao todo R$ 500,00 a menos do que o plano A custaria.",
      "B": "A decisão foi boa para o fabricante, pois o plano B custará ao todo R$ 1500,00 a menos do que o plano A custaria.",
      "C": "A decisão foi ruim para o fabricante, pois o plano B custará ao todo R$ 1000,00 a mais do que o plano A custaria.",
      "E": "A decisão foi ruim para o fabricante, pois o plano B custará ao todo R$ 6000,00 a mais do que o plano A custaria."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 913,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0914",
    "numero": 2414,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Duas amigas irão fazer um curso no exterior \ndurante 60 dias e usarão a mesma marca de \nxampu. Uma delas gasta um frasco desse xam-\npu em 10 dias enquanto que a outra leva 20 \ndias para gastar um frasco com o mesmo volu-\nme. Elas combinam de usar, conjuntamente, \ncada frasco de xampu que levarem. \n \nO número mínimo de frascos de xampu que \ndeverão levar nessa viagem é: \n \nA) 2. \nB) 4. \nC) 6. \nD) 8. \nE) 9.",
    "alternativas": {
      "D": "8.",
      "E": "9.",
      "B": "4.",
      "C": "6."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 914,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0915",
    "numero": 2415,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "No centro de uma praça será construída uma \nestátua que ocupará um terreno quadrado com \nárea de 9 metros quadrados. O executor da \nobra percebeu que a escala do desenho na \nplanta baixa do projeto é de 1 : 25. \n \nNa planta baixa, a área da figura que representa \nesse terreno, em centímetro quadrado, é \n \nA) 144. \nB) 225. \nC) 3600. \nD) 7500. \nE) 32400.",
    "alternativas": {
      "D": "7500.",
      "E": "32400.",
      "A": "144.",
      "C": "3600."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 915,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0916",
    "numero": 2416,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma indústria tem um setor totalmente automa-\ntizado. São quatro máquinas iguais, que traba-\nlham simultânea e ininterruptamente durante \numa jornada de 6 horas. Após esse período, as \nmáquinas são desligadas por 30 minutos para a \nmanutenção, ficará parada até a próxima manu-\ntenção. \n \nCerto dia, era necessário que as quatro máqui-\nnas produzissem um total de 9000 itens. O tra-\nbalho começou a ser feito às 8 horas.  \nDurante uma jornada de 6 horas, produziram \n6000 itens, mas na manutenção observou-se \nque uma máquina precisava ficar parada. \nQuando o serviço foi finalizado, as três máqui-\nnas que continuaram operando passaram por \numa nova manutenção, chamada manutenção \nde esgotamento. \n \nEm que horário começou a manutenção de es-\ngotamento? \n \nA) 16 h 45 min \nB) 18 h 30 min \nC) 19 h 50 min \nD) 21 h 15 min \nE) 22 h 30 min",
    "alternativas": {
      "D": "21 h 15 min",
      "E": "22 h 30 min",
      "A": "16 h 45 min",
      "B": "18 h 30 min"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 916,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0917",
    "numero": 2417,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "O gráfico mostra a expansão da base de assi-\nnantes de telefonia celular no Brasil, em milhões \nde unidades, no período de 2006 a 2011. \n \n \n \n(Disponível em: www.guiadocelular.com.  \nAcesso em: 1 ago. 2012) \n \nDe acordo com o gráfico, a taxa de crescimento \ndo número de aparelhos celulares no Brasil, de \n2007 para 2011, foi de: \n \nA) 8,53% \nB) 85,17% \nC) 103,04% \nD) 185,17% \nE) 345,00%",
    "alternativas": {
      "E": "345,00%",
      "A": "8,53%",
      "B": "85,17%",
      "D": "185,17%"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 917,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0918",
    "numero": 2418,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "O estado de qualquer substância gasosa é de-\nterminado pela medida de três grandezas: o \nvolume (V), a pressão (P) e a temperatura (T) \ndessa substância.  \n \nPara os chamados gases “ideais”, o valor do \nquociente \nT\nV\nP \né sempre constante. \nConsidere um reservatório que está cheio de \num gás ideal. Sem vazar o gás, realiza-se uma \ncompressão do reservatório, reduzindo seu \nvolume à metade. Ao mesmo tempo, uma fonte \nde calor faz a temperatura do gás ser quadrupli-\ncada. Considere P0 e P1 respectivamente, os \nvalores da pressão do gás no reservatório, an-\ntes e depois do procedimento descrito. \n \nA relação entre P0 e P1 é: \n \nA) \n8\n0\n1\nP\nP \n \nB) \n2\n0\n1\nP\nP \n \nC) P1 = P0 \n \nD) P1 = 2P0 \n \nE) P1 = 8P0",
    "alternativas": {
      "C": "P1 = P0",
      "E": "P1 = 8P0",
      "A": "8 0 1 P P ",
      "B": "2 0 1 P P "
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 918,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0919",
    "numero": 2419,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma repartição pública possui um sistema que \narmazena em seu banco de dados todos os \nofícios, memorandos e cartas enviados ao longo \ndos anos. Para organizar todo esse material e \nfacilitar a localização no sistema, o computador \nutilizado pela repartição gera um código para \ncada documento, de forma que os oito primeiros \ndígitos indicam a data em que o documento foi \nemitido (DDMMAAAA), os dois dígitos seguintes \nindicam o tipo de documento (ofício: 01, memo-\nrando: 02 e carta: 03) e os três últimos dígitos \nindicam a ordem do documento. Por exemplo, o \ncódigo 0703201201003 indica um ofício emitido \nno dia 7 de março de 2012, cuja ordem é 003. \nNo dia 27 de Janeiro de 2001, essa repartição \npública emitiu o memorando de ordem 012 e o \nenviou aos seus funcionários. \n \nO código gerado para esse memorando foi: \n \nA) 0122701200102. \nB) 0201227012001. \nC) 0227012001012. \nD) 2701200101202. \nE) 2701200102012.",
    "alternativas": {
      "E": "2701200102012.",
      "B": "0201227012001.",
      "C": "0227012001012.",
      "D": "2701200101202."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 919,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0920",
    "numero": 2420,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "A baixa procura por carne bovina e o aumento \nde oferta de animais para abate fizeram com \nque o preço da arroba do boi apresentasse \nqueda para o consumidor. No ano de 2012, o \npreço da arroba do boi caiu de R$ 100,00 para \nR$ 93,00. \n \n(Disponível em: www.diariodemarilia.com.br.  \nAcesso em: 14 ago. 2012) \nCom o mesmo valor destinado à aquisição de \ncarne, em termos de perda ou ganho, o consu-\nmidor: \n \nA) ganhou 6,5% em poder aquisitivo de carne. \nB) ganhou 7% em poder aquisitivo de carne. \nC) ganhou 7,5% em poder aquisitivo de carne. \nD) perdeu 7% em poder aquisitivo de carne. \nE) perdeu 7,5% em poder aquisitivo de carne.",
    "alternativas": {
      "D": "perdeu 7% em poder aquisitivo de carne.",
      "E": "perdeu 7,5% em poder aquisitivo de carne.",
      "B": "ganhou 7% em poder aquisitivo de carne.",
      "C": "ganhou 7,5% em poder aquisitivo de carne."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 920,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0921",
    "numero": 2421,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma pessoa encheu o cartão de memória de \nsua câmera duas vezes, somente com vídeos e \nfotos. Na primeira vez, conseguiu armazenar 10 \nminutos de vídeo e 190 fotos. Já na segunda, foi \npossível realizar 15 minutos de vídeo e tirar 150 \nfotos. Todos os vídeos possuem a mesma qua-\nlidade de imagem entre si, assim como todas as \nfotos. Agora, essa pessoa deseja armazenar \nnesse de memória exclusivamente fotos, com a \nmesma qualidade das anteriores. \n \n(Disponível em: www.techlider.com.br.  \nAcesso em: 31 jul. 2012) \n \nO número máximo de fotos que ela poderá ar-\nmazenar é: \n \nA) 200. \nB) 209. \nC) 270. \nD) 340. \nE) 475.",
    "alternativas": {
      "E": "475.",
      "A": "200.",
      "C": "270.",
      "D": "340."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 921,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0922",
    "numero": 2422,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "As empresas que possuem Serviço de Atendi-\nmento ao Cliente (SAC), em geral, informam ao \ncliente que utiliza o serviço um número de pro-\ntocolo de atendimento. Esse número resguarda \no cliente para eventuais reclamações e é gera-\ndo, consecutivamente, de acordo com os aten-\ndimentos executados.  \n \nAo término do mês de janeiro de 2012, uma \nempresa registrou como último número de pro-\ntocolo do SAC o 390 978 467. Do início do mês \nde fevereiro até o fim do mês de dezembro de \n2012, foram abertos 22 580 novos números de \nprotocolos. \n \nO algarismo que aparece na posição da dezena \nde milhar do último número de protocolo de \natendimento registrado em 2012 pela empresa \né: \n \nA) 0. \nB) 2. \nC) 4. \nD) 6. \nE) 8.",
    "alternativas": {
      "B": "2.",
      "D": "6.",
      "E": "8.",
      "A": "0."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 922,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0924",
    "numero": 2424,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Nas informações veiculadas nos órgãos de co-\nmunicação quando da ocorrência de um terre-\nmoto, faz-se referência à magnitude (M), que se \nrefere a quantos graus o fenômeno atingiu na \nescala Richter. Essa medida quantifica a ener-\ngia liberada no epicentro do terremoto, e em seu \ncálculo utilizam-se como parâmetros as medi-\ndas da amplitude sísmica (A), em micrômetro, e \nda frequência (f), em hertz. Esses parâmetros \nsão medidos por aparelhos especiais chamados \nsismógrafos, e relacionam-se segundo a função \nM = log (A x f) + 3,3. Pela magnitude do terre-\nmoto na escala Richter, pode-se estimar seus \nefeitos de acordo com o quadro, onde não estão \nconsiderados terremotos de magnitudes superi-\nores a 7,9. \n \n \n \nUm terremoto teve sua amplitude e frequências \nmedidas e obteve-se A = 1000 micrômetros e f \n= 0,2 hertz. \n  \nUse -0,7 como aproximação para log (0,2). \n \n(Disponível em: www.mundoeducação.com.br.  \nAcesso em: 11 jul. 2012 - adaptado)  \n \nConsiderando o quadro apresentado, e anali-\nsando o resultado da expressão que fornece a \nmagnitude desse terremoto, conclui-se que ele \nfoi: \n \nA) registrado, mas não percebido pelas pesso-\nas.  \nB) percebido, com pequenos tremores notados \npelas pessoas. \nC) destrutivo, com consequências significativas \nem edificações pouco estranhas.  \nD) destrutivo, com consequências significativas \npara todo tipo de edificação. \nE) destrutivo, com consequências nas funda-\nções dos edifícios, fendas no solo e tubulações \nno subsolo.",
    "alternativas": {
      "B": "percebido, com pequenos tremores notados pelas pessoas.",
      "C": "destrutivo, com consequências significativas em edificações pouco estranhas.",
      "D": "destrutivo, com consequências significativas para todo tipo de edificação.",
      "A": "registrado, mas não percebido pelas pesso- as."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 924,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0925",
    "numero": 2425,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Estimativas do IBGE para a safra nacional de \ncereais, leguminosas e oleaginosas, em 2012, \napontavam uma participação por região confor-\nme indicado no gráfico. \n \n \nAs estimativas indicavam que as duas regiões \nmaiores produtoras produziriam, juntas, um total \nde 119,9 milhões de toneladas dessas culturas, \nem 2012. \n(Disponível em: www.ibge.gov.br.  \nAcesso em: 3 jul. 2012) \n \nDe acordo com esses dados, qual seria o valor \nmais próximo da produção, em milhão de tone-\nlada, de cereais, leguminosas, em 2012, na \nRegião Sudeste do país? \n \nA) 10,3 \nB) 11,4 \nC) 13,6 \nD) 16,5 \nE) 18,1",
    "alternativas": {
      "C": "13,6",
      "D": "16,5",
      "E": "18,1",
      "B": "11,4"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 925,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0926",
    "numero": 2426,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Em certa loja de roupas, o lucro na venda de \numa camiseta é de 25% do preço de custo da \ncamiseta pago pela loja. Já o lucro na venda de \numa bermuda é de 30% do preço de custo da \nbermuda, e na venda de uma calça o lucro é de \n20% sobre o preço de custo da calça. Um clien-\nte comprou nessa loja duas camisetas, cujo \npreço de custo foi R$ 40,00 cada uma, uma \nbermuda que teve preço de custo de R$ 60,00 e \nduas calças, ambas com mesmo preço de cus-\nto. Sabe-se que, com essa compra, o cliente \nproporcionou um lucro de R$ 78,00 para a loja. \n \nConsiderando essas informações, qual foi o \npreço de custo, em real, pago por uma calça? \n \nA) 90 \nB) 100 \nC) 125 \nD) 195 \nE) 200",
    "alternativas": {
      "A": "90",
      "B": "100",
      "D": "195",
      "E": "200"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 926,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0927",
    "numero": 2427,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Um marceneiro recebeu a encomenda de uma \npassarela de 14,935 m sobre um pequeno lago, \nconforme a Figura I. A obra será executada com \ntábuas de 10 cm de largura, que já estão com o \ncomprimento necessário para instalação, dei-\nxando-se um espaçamento de 15mm entre tá-\nbuas consecutivas, de acordo com a planta do \nprojeto na Figura II. \n \n \n \n \n \nDesconsiderando-se eventuais perdas com \ncortes durante a execução do projeto, quantas \ntábuas, no mínimo, o marceneiro necessitará \npara a execução da encomenda? \n \nA) 60 \nB) 100 \nC) 130 \nD) 150 \nE) 598",
    "alternativas": {
      "A": "60",
      "B": "100",
      "C": "130",
      "E": "598"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 927,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0928",
    "numero": 2428,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma escola organizou uma corrida de reveza-\nmento 4 x 400 metros, que consiste em uma \nprova esportiva na qual os atletas correm 400 \nmetros cada um deles, segurando um bastão, \nrepassando-o de um atleta para outro da mes-\nma equipe, realizando três trocas ao longo do \npercurso, até o quarto atleta, que cruzará a linha \nde chegada com o bastão.  \nA equipe ganhadora realizou a prova em um \ntempo total de 325 segundos. \n \nO segundo corredor da equipe ganhadora cor-\nreu seus 400 metros 15 segundos mais rápido \ndo que o primeiro; já o terceiro realizou seus \n400 metros 5 segundos mais rápido que o se-\ngundo corredor, e o último realizou seu percurso \nem 3/4 do tempo realizado pelo primeiro. \n \nQual foi o tempo, em segundo, em que o último \natleta da equipe ganhadora realizou seu percur-\nso de 400 metros? \n \nA) 58 \nB) 61 \nC) 69 \nD) 72 \nE) 96",
    "alternativas": {
      "A": "58",
      "B": "61",
      "C": "69",
      "D": "72"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 928,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0929",
    "numero": 2429,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma fábrica de papel higiênico produz embala-\ngens com quatro rolos de 30 m cada, cujo preço \npara o consumidor é R$ 3,60. Uma nova emba-\nlagem com dez rolos de 50 m cada, de mesma \nlargura, será lançada no mercado. O preço do \nproduto na nova embalagem deve ser equiva-\nlente ao já produzido, mas, para incentivar as \nvendas, inicialmente o preço de venda terá um \ndesconto de 10%. \n \nPara que isso aconteça, o preço de venda da \nnova embalagem, em real, deve ser: \n \nA) 8,10. \nB) 9,00. \nC) 9,90. \nD) 13,50. \nE) 15,00.",
    "alternativas": {
      "B": "9,00.",
      "C": "9,90.",
      "D": "13,50.",
      "A": "8,10."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 929,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0930",
    "numero": 2430,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "O hábito cristalino é um termo utilizado por mi-\nneralogistas para descrever a aparência típica \nde um cristal em termos de tamanho e forma. A \ngranada é um mineral cujo hábito cristalino é um \npoliedro com 30 arestas e 20 vértices. Um mine-\nralogista construiu um modelo ilustrativo de um \ncristal de granada pela junção dos polígonos \ncorrespondentes às faces. \n \nSupondo que o poliedro ilustrativo de um cristal \nde granada é convexo, então a quantidade de \nfaces utilizadas na montagem do modelo ilustra-\ntivo desse cristal é igual a: \n \nA) 10. \nB) 12. \nC) 25. \nD) 42. \nE) 50.",
    "alternativas": {
      "C": "25.",
      "D": "42.",
      "E": "50.",
      "B": "12."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 930,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0931",
    "numero": 2431,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Um sistema de depreciação linear, estabele-\ncendo que após 10 anos o valor monetário de \num bem será zero, é usado nas declarações de \nimposto de renda de alguns países. O gráfico \nilustra essa situação. \n \n \n \nUma pessoa adquiriu dois bens, A e B, pagando \n1200 e 900 dólares, respectivamente. \n \nConsiderando as informações dadas, após 8 \nanos, qual será a diferença entre os valores \nmonetários, em dólar, desses bens? \n \nA) 30 \nB) 60 \nC) 75 \nD) 240 \nE) 300",
    "alternativas": {
      "B": "60",
      "D": "240",
      "E": "300",
      "A": "30"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 931,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0932",
    "numero": 2432,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Um programa de televisão criou um perfil em \numa rede social, e a ideia era que esse perfil \nfosse sorteado para um dos seguidores, quando \nesses fossem em número de um milhão. Agora \nque essa quantidade de seguidores foi atingida, \nos organizadores perceberam que apenas 80% \ndeles são realmente fãs do programa. Por conta \ndisso, resolveram que todos os seguidores farão \num teste, com perguntas objetivas referentes ao \nprograma, e só poderão participar do sorteio \naqueles que forem aprovados. Estatísticas reve-\nlam que, num teste dessa natureza, a taxa de \naprovação é de 90% dos fãs e de 15% dos que \nnão são fãs. \n \nDe acordo com essas informações, a razão \nentre a probabilidade de que um fã seja sortea-\ndo e a probabilidade de que o sorteado seja \nalguém que não é do programa é igual a: \n \nA) 1. \nB) 4. \nC) 6. \nD) 24. \nE) 96.",
    "alternativas": {
      "B": "4.",
      "D": "24.",
      "E": "96.",
      "A": "1."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 932,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0933",
    "numero": 2433,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma televisão pode ser posicionada de modo \nque se consiga enxergar os detalhes de uma \nimagem em alta definição.  \n \nConsidere que a distância ideal, com conforto \nvisual, para se assistir à televisão de 32 polega-\ndas é de 1,8 metro.  \n \nSuponha que haja uma relação de proporciona-\nlidade direta entre o tamanho da tela (medido \nem polegada) e a distância ideal. Considere que \num espectador dispõe de uma televisão de 60 \npolegadas e que ele deseja se posicionar em \nfrente a ela, com conforto visual. \n \nA distância de televisão, em metro, em que o \nespectador deve se posicionar para que tenha \nconforto visual é mais próxima de: \n \nA) 0,33. \nB) 0,96. \nC) 1,57. \nD) 3,37. \nE) 3,60.",
    "alternativas": {
      "B": "0,96.",
      "C": "1,57.",
      "D": "3,37.",
      "A": "0,33."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 933,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0934",
    "numero": 2434,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "No primeiro ano do ensino médio de uma esco-\nla, é hábito os alunos dançarem quadrilha na \nfesta junina. Neste ano, há 12 meninas e 13 \nmeninos na turma, e para a quadrilha foram \nformados 12 pares distintos, compostos por \numa menina e um menino.  \n \nConsidere que as meninas sejam os elementos \nque compõem o conjunto A e os meninos, o \nconjunto B, de modo que os pares formados \nrepresentam uma função f de A em B. \n \nCom base nessas informações, a classificação \ndo tipo de função que está presente nessa rela-\nção é: \n \nA) f é injetora, pois para cada menina perten-\ncente ao conjunto A está associado um menino \ndiferente pertencente ao conjunto B. \nB) f é sobrejetora, pois cada par é formado por \numa menina pertencente ao conjunto A e um \nmenino pertencente ao conjunto B, sobrando \num menino sem formar par. \nC) f é injetora, pois duas meninas quaisquer \npertencentes ao conjunto A formam par com um \nmesmo menino pertencente ao conjunto B, para \nenvolver a totalidade de alunos da turma. \nD) f é bijetora, pois dois meninos quaisquer \npertencentes ao conjunto B formam par com \numa mesma menina pertencente ao conjunto A. \nE) f é sobrejetora, pois basta que uma menina \ndo conjunto A forme par com dois meninos per-\ntencentes ao conjunto B, assim nenhum menino \nficará sem par.",
    "alternativas": {
      "B": "f é sobrejetora, pois cada par é formado por uma menina pertencente ao conjunto A e um menino pertencente ao conjunto B, sobrando um menino sem formar par.",
      "C": "f é injetora, pois duas meninas quaisquer pertencentes ao conjunto A formam par com um mesmo menino pertencente ao conjunto B, para envolver a totalidade de alunos da turma.",
      "D": "f é bijetora, pois dois meninos quaisquer pertencentes ao conjunto B formam par com uma mesma menina pertencente ao conjunto A.",
      "A": "f é injetora, pois para cada menina perten- cente ao conjunto A está associado um menino diferente pertencente ao conjunto B."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 934,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0935",
    "numero": 2435,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Um funcionário da Secretaria de Meio Ambiente \nde um município resolve apresentar ao prefeito \num plano de priorização para a limpeza das \nlagoas da cidade. Para a execução desse plano, \no prefeito decide voltar suas ações, primeira-\nmente, para aquela lagoa que tiver o maior coe-\nficiente de impacto, o qual é definido como o \nproduto entre o nível de contaminação médio \npor mercúrio em peixes e o tamanho da popula-\nção ribeirinha. O quadro mostra as lagoas do \nmunicípio e suas correspondentes informações. \n \n \n \nA primeira lagoa que sofrerá a intervenção pla-\nnejada será a: \n \nA) Antiga. \nB) Bela. \nC) Delícia. \nD) Salgada. \nE) Vermelha.",
    "alternativas": {
      "B": "Bela.",
      "C": "Delícia.",
      "D": "Salgada.",
      "E": "Vermelha."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 935,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0936",
    "numero": 2436,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Para a Olimpíada de 2012, a piscina principal do \nCentro Aquático de Londres, medindo 50 metros \nde comprimento, foi remodelada para ajudar os \natletas a melhorar suas marcas. Observe duas \ndas melhorias: \n \n \n(Veja, n. 2278, jul. 2012 - adaptado) \n \nA capacidade da piscina em destaque, em me-\ntro cúbico, é igual a: \n \nA) 3750. \nB) 1500. \nC) 1250. \nD) 375. \nE) 150.",
    "alternativas": {
      "E": "150.",
      "A": "3750.",
      "C": "1250.",
      "D": "375."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 936,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0937",
    "numero": 2437,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Um fabricante recomenda que, para cada m² do \nambiente a ser climatizado, são necessários \n800 BTUh, desde que haja até duas pessoas no \nambiente. A esse número devem ser acrescen-\ntados 600 BTUh para cada pessoa a mais, e \ntambém para cada aparelho eletrônico  emissor \nde calor no ambiente. A seguir encontram-se as \ncinco opções de aparelhos desse fabricante e \nsuas respectivas capacidades térmicas: \n \nTipo I: 10 500 BTUh \nTipo II: 11 000 BTUh \nTipo III: 11 500 BTUh \nTipo IV: 12 000 BTUh \nTipo V: 12 500 BTUh \n \nO supervisor de um laboratório precisa comprar \num aparelho para climatizar o ambiente. Nele \nficarão duas pessoas mais uma centrífuga que \nemite calor. O laboratório tem forma de trapézio \nretângulo, com as medidas apresentadas na \nfigura. \n \n \n \nPara economizar energia, o supervisor deverá \nescolher o aparelho de menor capacidade tér-\nmica que atenda às necessidades do laboratório \ne às recomendações do fabricante. \n \nA escolha do supervisor recairá sobre o apare-\nlho do tipo: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "C": "III.",
      "E": "V.",
      "A": "I.",
      "B": "II."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 937,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0938",
    "numero": 2438,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Os consumidores X, Y e Z desejam trocar seus \nplanos de internet móvel na tentativa de obte-\nrem um serviço de melhor qualidade. Após pes-\nquisarem, escolheram uma operadora que ofe-\nrece cinco planos para diferentes perfis, con-\nforme apresentado no quadro. \n \nDado: 1 GB = 1 024 MB \n \nEm cada plano, o consumidor paga um valor \nfixo (preço mensal da assinatura) pela franquia \ncontratada e um valor variável, que depende da \nquantidade de MB utilizado além da franquia. \nConsidere que a velocidade máxima de acesso \nseja a mesma, independentemente do plano, \nque os consumos mensais de X, Y e Z são de \n190 MB, 450 MB e 890 MB, respectivamente, e \nque cada um deles escolherá apenas um plano. \n \nCom base nos dados do quadro, as escolhas \ndos planos com menores custos para os con-\nsumidores X, Y e Z, respectivamente, são: \n \nA) A, C e C. \nB) A, B e D. \nC) B, B e D. \nD) B, C e C. \nE) B, C e D.",
    "alternativas": {
      "E": "B, C e D.",
      "A": "A, C e C.",
      "B": "A, B e D.",
      "C": "B, B e D."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 938,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];